import {
  Component,
  Input,
  AfterViewInit,
  ViewChild,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { RouterOutlet, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    MatSidenavModule,
    RouterOutlet,
    HeaderComponent,
    SidebarComponent,
    RouterModule,
    MatToolbar,
    MatIcon,
  ],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  @Input() username: string = '';
  isMobile = false;
  isSideBarOpen = true;

  constructor(private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    this.setupViewport();
  }

  setupViewport(): void {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isMobile = result.matches;
        this.isSideBarOpen = !this.isMobile;
        if (this.sidenav) {
          this.isSideBarOpen ? this.sidenav.open() : this.sidenav.close();
        }
      });
  }

  ngAfterViewInit(): void {
    // Garantir que a sidenav está no estado correto ao iniciar
    if (this.isMobile && this.sidenav) {
      this.sidenav.close();
    } else if (this.sidenav) {
      this.sidenav.open();
    }
  }

  toggleSidebar(): void {
    this.isSideBarOpen = !this.isSideBarOpen;
    if (this.sidenav) {
      this.isSideBarOpen ? this.sidenav.open() : this.sidenav.close();
    }
  }

  onSidebarClosed(): void {
    console.log('Sidebar closed');
  }
}